import { useEffect } from "react";
import Accounts from "../Accounts";
import { useBottomMenuSections } from "../../../../contexts/bottomMenuSections";
import { useAccounts } from "../../../../contexts/accounts";

const AdminHome = () => {
  const { accounts } = useAccounts();
  const { setBottomMenuSections } = useBottomMenuSections();

  useEffect(() => {
    setBottomMenuSections("admin");
  }, []);

  return (
    <>
      <Accounts accounts={accounts} />
    </>
  );
};

export default AdminHome;
